import { routes as widget } from './widget'
import { routes as institution } from './institution'

export default [ ...widget, ...institution ]



// WEBPACK FOOTER //
// ./src/app/unmudlWebWidgetRoutes.js